import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Button, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import AsyncSelect from "react-select/async";
import Select, {components} from 'react-select'
import TextareaAutosize from "react-textarea-autosize";
import Loader from "../components/Loader";
import { baseUrl } from "../constants/environment";
import APIClient from "../helpers/APIClient";
import PriceUtils from "../helpers/PriceUtils";
import { toast } from "react-toastify";
import moment from 'moment'

const Presenter = (props: any) => {
  const {closeModal, data, user_operation} = props;
  const [loading, setLoading] = useState(false);
  const [dataIntroduce, setDataIntroduce] = useState<any>({
    recommender_id: data?.doctor_infor || data?.doctor_info,
    customer_id: (data?.customer_presenter && data?.customer_presenter !== '') ? data?.customer_presenter : data?.customer_id ,
    active_time : moment().valueOf(), 
    active_time_config : moment().valueOf(), 
  });
  const [servicePack, setServicePack] = useState<any>();
  const [user, setUser] = useState<any>();
  const [queryIntroduce, setQueryIntroduce] = useState<any>();
  const [typeIntroduce, setTypeIntroduce] = useState<any>(false);
  // user thao tác : user_operation

  useEffect(() => {
    fetchServicePack();
    loadDataUser();
  },[])

  useEffect(() => {
    if(data?.id) {
      loadDataIntroduce();
    }
  }, [data?.id])

  const loadDataUser = async () => {
    setLoading(true);
    const formData = {
      limit: 100,
      role: 'user'
    }
    const url = `${baseUrl}/user`;
    let response: any = await APIClient.GET(url, formData);
    setLoading(false)
    if (response.error !== undefined) {
        toast.error(response.error)
    } else if (response.response?.data !== undefined) {
        const ArrUser: any = [];
        response?.response?.data?.map((item: any) => {
          ArrUser?.push({
            ...item,
            label: item?.name,
            value: item?.id
          })
        })
        setUser(ArrUser)
    }
  }

  const fetchServicePack = async () => {
    const url = `${baseUrl}/servicepackage`;
    setLoading(true);
    let response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error);
    } else if (response.response !== undefined) {
      const Arr: any = [];
      response.response?.data?.map((e: any) => {
        if(e?.status == 1) {
          Arr.push({
            ...e,
            value: e?.id,
            label: e?.name,
            servicepackage_id: {
              name: e?.name
            }
          })
        }
      })
      setServicePack(Arr);
    }
  }

  const handleInputChangeIntroduce = (newValue: any) => {
      setQueryIntroduce(newValue);
      return newValue;
    };
  
  const loadIntroduceSearch = async () => {
    setLoading(true)
    let response: any = await APIClient.GET(`${baseUrl}/user`, {
      page: 1,
      limit: 20,
      role: 'user',
      name: queryIntroduce,
    });
    setLoading(false)
    if (response.response?.data !== undefined) {
      let Arr: any = [];
      response.response?.data?.map((e: any) => {
        Arr?.push({
          value: e?.id,
          label: e?.name,
          ...e,
        });
      });
      return Arr
    }
  };
  
  const loadDataIntroduce = async () => {
    const url = `${baseUrl}/orderspackage/examination/${data?.id}`;
    setLoading(true);
    const response: any = await APIClient.GET(url);
    setLoading(false);
    if (response.error !== undefined) {
      // toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      const resData = await response.response;
      setDataIntroduce({
        servicepackage_id: resData?.orderspackage_services?.[0]?.servicepackage_id,
        note: resData?.note,
        recommender_id: resData?.recommender_id,
        customer_id: resData?.customer_id,
        id: resData?.id
      });
      setTypeIntroduce(true);
    }
  }

  const CustomOptionOrderPackage = ({ innerProps, data }: any) => {
    const Label_card_packs: any = (value: any) => {
        if (value == 'membership_card') {
            return 'Gói thẻ thành viên'
        }
        if (value == 'account_card') {
            return 'Gói thẻ tài khoản'
        }
        if (value == 'stage') {
            return 'Dịch vụ theo giai đoạn phát triển của trẻ'
        }
        if (value == 'course') {
            return 'Khoá học dinh dưỡng'
        }
    }
    
    const convertToDisplayName = (type: any) => {
        switch (type) {
          case 'nhi':
            return 'Nhi';
          case 'dinh_duong':
            return 'Dinh Dưỡng';
          default:
            return type;
        }
    }

    const convertExpiry_type = (type: any) => {
      switch (type) {
        case 'day':
          return 'Ngày'
          break;
        case 'month':
          return 'Tháng'
          break;
        case 'year':
          return 'Năm'
          break;
        default:
          break;
      }
    }

    const formatExam_type = data?.examination_type?.map((type : any) => convertToDisplayName(type));

    return (
        <div {...innerProps} style={{ display: 'flex', justifyContent: 'space-between', padding: "10px", borderBottom: "solid 1px #DCDCDC", cursor: 'pointer'}}>
          <div style={{width: '60%'}}>
              <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{data?.code} - {data?.servicepackage_id?.name}</div>
              <div>Loại gói thẻ: {Label_card_packs(data?.type)}</div>
              <div>Chiết khấu dịch vụ: <span style={{color: '#48A800'}}>{data?.discount_service_examination || 0}%</span></div>
              <div>Loại khám: {formatExam_type?.join('/')}</div>
              {
                data?.type == 'membership_card' ? (
                  <div>Hạng thành viên: {data?.customer_rank_config_line_id?.rank_name}</div>
                ) : null
              }
          </div>
          <div style={{width: '40%', textAlign: 'end'}}>
              <div>
                <a className='textDecoration' href={`/servicepack/${data?.id}/view`} style={{ color: 'blue', fontStyle: 'italic', textDecorationColor: 'lightblue' }} target="_blank">Xem chi tiết</a>
              </div>
              <div>Giá tiền: <span style={{color: '#48A800'}}>{PriceUtils.format((Number(data?.price)), 'đ')}</span></div>
              <div>Chiết khấu đơn hàng: <span style={{color: '#48A800'}}>{data?.discount_order || 0}%</span></div>
              <div>Hạn sử dụng: {data?.expiry_number == null ? 'Không thời hạn' : `${data?.expiry_number} ${convertExpiry_type(data?.expiry_type)}`}</div>
          </div>
        </div>
    );
  }

  const formatOptionLabel = ({ code, name } : any) => (
    <div>
      <span>{code} - {name}</span>
    </div>
  );

  const handleChangeInput = (event?: any) => {
    let { value, name } = event.target
    if (value === " ") return;
    if (name === "phone") {
      value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
    }
    setDataIntroduce({
      ...dataIntroduce,
      [name]: value
    })
  }

  const validate_introduce = () => {
    if(!dataIntroduce?.recommender_id) {
      toast.warning('Người giới thiệu không được để trống!');
      return false
    }
    if(!dataIntroduce?.servicepackage_id?.id) {
      toast.warning('Gói dịch vụ giới thiệu không được để trống!');
      return false
    }
    if(!dataIntroduce?.customer_id?.id) {
      toast.warning('Khách hàng không được để trống!');
      return false
    }
    return true
  }

  const handleSubmitIntroduce = async () => {
    if(!validate_introduce()) return;
    const params : any= {
      note: dataIntroduce?.note,
      orderspackage_services: [{
        servicepackage_id: dataIntroduce?.servicepackage_id?.id,
        quantity: 1,
        price: dataIntroduce?.servicepackage_id?.price
      }],
      recommender_id: dataIntroduce?.recommender_id?.id,
      customer_id: dataIntroduce?.customer_id?.id,
      branch_id: data?.branch_id?.id || data?.branch?.id || user_operation?.branch_id?.id,
      customer_ids: [dataIntroduce?.customer_id?.id],
      examination_id: data?.id
    }
    if (dataIntroduce?.servicepackage_id?.type !== "account_card") {
      params.orderspackage_services[0] = {
        ...params.orderspackage_services[0],
        active_time: dataIntroduce?.active_time,
        active_time_config: dataIntroduce?.active_time_config
      };
    }
    const url = `${baseUrl}/orderspackage`;
    setLoading(true);
    const response: any = await APIClient.POST(url, params);
    setLoading(false);
    if (response.error !== undefined) {
      toast.error(response.error.error_description);
    } else if (response.response !== undefined) {
      toast.success("Thao tác thành công");
      closeModal();
    }
  }

  const router = useHistory();

  return (
    <CardBody className="p-0" style={{ width: 800 }}>
        <div className="modal-header">
          <h5 className="modal-title" id="modal-action-title">
            Giới thiệu gói dịch vụ
          </h5>
          <button onClick={() => closeModal()} type="button" className="close">
            {" "}
            <span aria-hidden="true">×</span>{" "}
          </button>
        </div>
        <div className={typeIntroduce == false ? `modal-body pt-2 pb-2` : `modal-body pt-2 pb-2 only-view`}>
          <Row>
            <Col md={4}>
              <FormGroup className="nutri-form">
                <Label><span>*</span>Người giới thiệu</Label>
                <AsyncSelect
                  className="react-select mb-2 react-select2-line"
                  classNamePrefix="react-select"
                  onInputChange={handleInputChangeIntroduce}
                  loadOptions={loadIntroduceSearch}
                  inputValue={queryIntroduce}
                  placeholder={loading ? "Đang tải dữ liệu..." : "Tìm kiếm tên/số điện thoại"}
                  noOptionsMessage={() => queryIntroduce ? "Không tìm thấy dữ liệu" : 'Tìm kiếm tên/số điện thoại'}
                  loadingMessage={() => 'Đang tìm kiếm...'}
                  cacheOptions
                  style={{ padding: 0 }}
                  defaultOptions={user || []}
                  onChange={(val: any) => {
                    setDataIntroduce({
                      ...dataIntroduce,
                      recommender_id: val
                    })
                  }}
                  value={user?.filter((item: any) => item?.value == dataIntroduce?.recommender_id?.id)}
                  components={{
                    Menu: (props: any) => (
                      <components.Menu {...props} >
                        {props.children}
                      </components.Menu>
                    )
                  }} 
                  isDisabled={typeIntroduce == true}  
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup className="nutri-form">
                <Label><span>*</span>Khách hàng</Label>
                <p style={{marginTop: 8}}>{dataIntroduce?.customer_id?.name || '---'}</p>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup className="nutri-form">
                <Label><span>*</span>Số điện thoại</Label>
                <p style={{marginTop: 8}}>
                  {dataIntroduce?.customer_id?.phone || '---'}
                </p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={8}>
              <FormGroup className="nutri-form">
                <Label><span>*</span>Gói dịch vụ giới thiệu</Label>
                <Select 
                  placeholder="Chọn"
                  className="react-select"
                  classNamePrefix="react-select"
                  maxMenuHeight={250}
                  options={servicePack || []}
                  components={{
                    Option: CustomOptionOrderPackage
                  }}
                  value={servicePack?.find((option: any) => dataIntroduce?.servicepackage_id?.id === option.value)}
                  onChange={(val: any) => {
                    setDataIntroduce({
                      ...dataIntroduce,
                      servicepackage_id: val
                    })
                  }}
                  formatOptionLabel={formatOptionLabel}
                  isDisabled={typeIntroduce == true}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup className="nutri-form">
                <Label>Tổng tiền tạm tính</Label>
                <p style={{fontSize: 16, color: '#48A800', marginTop: 5}}>
                  {PriceUtils.format(dataIntroduce?.servicepackage_id?.price) || '---'}
                </p>
              </FormGroup>
            </Col>
          </Row>
          {
            <Row>
              <Col md={8}>
                <FormGroup className="nutri-form">
                  <Label>Ghi chú</Label>
                  {
                    typeIntroduce == true ? (
                      <TextareaAutosize
                        minRows={1}
                        maxRows={5}
                        onChange={(e: any) => handleChangeInput(e)}
                        name="note"
                        placeholder={
                          "Nhập ghi chú"
                        }
                        value={dataIntroduce?.note}
                        className="pointer"
                        disabled
                      />
                    ) : (
                      <TextareaAutosize
                        minRows={1}
                        maxRows={5}
                        onChange={(e: any) => handleChangeInput(e)}
                        name="note"
                        placeholder={
                          "Nhập ghi chú"
                        }
                        value={dataIntroduce?.note}
                      />
                    )
                  }
                  
                </FormGroup>
              </Col>
            </Row>
          }    
        </div>
        <div className="modal-footer">
          {
            typeIntroduce == false ? (
              <>
                <Button
                  onClick={closeModal}
                  className="ml-2 success-bland"
                  color="success"
                  type="button"
                >
                  {" "}
                  Hủy bỏ
                </Button>
                <Button
                  onClick={() => handleSubmitIntroduce()}
                  className="ml-2 success"
                  color="success"
                  type="button"
                >
                  {" "}
                  Xác nhận
                </Button>
              </>
            ) : 
              <Button
                onClick={() => {
                  window.open(`/packageorder/${dataIntroduce?.id}/view`)
                  closeModal();
                }}
                className="ml-2 success"
                color="success"
                type="button"
              >
                {" "}
                Xem chi tiết
              </Button>
          }
        </div>
        {loading && <Loader />}
    </CardBody>
  )
}

export default Presenter;